export default {
  methods: {
    productPeriodicity(size){
      if(product?.spaces_product_periodicity?.periodicity){
        let periodicityByLocale = product.spaces_product_periodicity.periodicity.split(" | ")[ this.locale == 'en' ? 0 : 1 ]
        if (size == 'long'){
          return periodicityByLocale
            .split("<")[0] // Remove abbreviation from string 
            .replace(".", '<br/>'); //Add break if string has a . character
        } else if ('short') {
          return periodicityByLocale.split("<")[1].split(">")[0]
        }
      } else {
        return ""
      }
    },
  }
}